import script from "./PatientAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientAdd.vue?vue&type=script&setup=true&lang=js"

import "./PatientAdd.vue?vue&type=style&index=0&id=13c56486&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c56486"]])

export default __exports__